// extracted by mini-css-extract-plugin
export default {"Checkbox":"styles_Checkbox__I-Hzk","top":"styles_top__x7H7r","small":"styles_small__nakw-","Checked":"styles_Checked__9afiz"};